<div class="modal" [ngClass]="{ show: isVisible }">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title fs-5" id="addNoteLabel">
          Add Note
        </h2>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="closeModal()"
        ></button>
      </div>
      <div class="modal-body">
        <form
          [formGroup]="noteForm"
          class="row g-3 align-items-center"
        >
          <div>
            <textarea
              class="form-control"
              placeholder="Add Note"
              id="add_note"
              style="min-height: 100px"
              formControlName="description"
            >
            </textarea>
          </div>
          <div>
            <div class="col-12">
              <ng-container
                *ngIf="
                  noteForm.get('description')?.invalid &&
                  (noteForm.get('description')?.dirty ||
                    noteForm.get('description')?.touched)
                "
              >
                <small class="text-danger">
                  <span
                    *ngIf="noteForm.get('description')?.errors?.['required']"
                  >
                    Please enter note.
                  </span>
                </small>
              </ng-container>
            </div>
          </div>
          <div>
            <button
              type="button"
              class="btn btn-outline-info"
              aria-label="Close"
              (click)="closeModal()"
            >
              Cancel
            </button>
            <button
              type="submit"
              [disabled]="noteForm.get('description')?.errors?.['required'] || isButtonDisabled"
              class="btn btn-info smallfix"
              (click)="onAddNote()"
            >
              Add Note
            </button>
          </div>
        </form>
        <div *ngIf="noteList.length > 0" class="cust-height">
          <table class="table text-left pt-3">
            <thead>
              <tr class="sticky-top-note">
                <th class="bg-info-light-tbl">Activity Date Time</th>
                <th class="bg-info-light-tbl">Description</th>
                <th class="bg-info-light-tbl">logged In User</th>
                <th class="bg-info-light-tbl" *ngIf="isSuperAdminUser">Delete</th>
              </tr>
            </thead>
            <tbody>
              <ng-container
                *ngFor="
                  let notes of noteList;
                  let i = index
                "
              >
                <tr class="">
                  <td>
                    {{ notes.createdTime | date:'dd/MM/yyyy HH:mm a'}}
                  </td>
                  <td>
                    {{ notes.description }}
                  </td>
                  <td>
                    {{ notes.loggedInUser }}
                  </td>
                  <td *ngIf="isSuperAdminUser">
                    <img
                      class="delete-icon"
                      src="assets/icons/w2c/delete.png"
                      (click)="deleteNote(notes)"
                    />
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" [ngClass]="{ show: isVisibleConfirm }">
  <div class="modal-dialog-popup modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
          <div class="g-3 align-items-center">
            Are you sure you want to delete this item?
          </div>
          <div class="pt-3">
            <button
              type="submit"
              class="btn btn-info"
              style="margin-right: 5px;"
              (click)="onDeleteNote()"
            >
              Yes
            </button>
            <button
              type="button"
              class="btn btn-outline-info"
              aria-label="Close"
              (click)="closeConfirmPopup()"
            >
              No
            </button>
          </div>
      </div>
    </div>
  </div>
</div>

<p-toast [life]="900000"></p-toast>
